export type IExperimentGroup = 'test' | 'control' | null;
export const MOBILE_WEB_PDP_EXPERIMENT = {
  TEST: 'test' as IExperimentGroup,
  CONTROL: 'control' as IExperimentGroup,
  NONE: null,
};
